import React, { useEffect, useMemo,useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Table from 'components/customTable';

import { formatter, kCurrencyFormatter, yearlySalaryToHourlyRate } from '../utils';

import salaryPageStyles from '../css/salaryJobPage.module.css';

const EXPERIENCE_LEVELS = {
  ENTRY_LEVEL: 'Entry-level',
  MID_LEVEL: 'Mid-level',
  SENIOR_LEVEL: 'Senior-level',
};

// React custom hook that can also be used elsewhere for window resize event.
export function useWindowResize() {
  const [innerWidth, setInnerWidth] = useState(0);
  useEffect(() => {
    function updateInnerWidth() {
      setInnerWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateInnerWidth);
    updateInnerWidth();
    return () => window.removeEventListener('resize', updateInnerWidth);
  }, []);
  return innerWidth;
}

export default function SalaryByExperienceLevel(props) {
  const { title, salaryByLevel, salaryByLevelContent } = props;
  const salaries = salaryByLevel.map((salary) => salary.median);

  const tableData = useMemo(() => {
    try {
      if (!salaries || salaries.length % 2 === 0) return [];
      else {
        let junior = {
          experienceLevel: `${EXPERIENCE_LEVELS.ENTRY_LEVEL} ${title?.toLowerCase?.()}`,
          avgSalary: salaries[0],
          hourlyRate: null,
        };
        junior.hourlyRate = yearlySalaryToHourlyRate(junior.avgSalary);
        let mid = {
          experienceLevel: `${EXPERIENCE_LEVELS.MID_LEVEL} ${title?.toLowerCase?.()}`,
          avgSalary: salaries[parseInt(salaries.length / 2)],
          hourlyRate: null,
        };
        mid.hourlyRate = yearlySalaryToHourlyRate(mid.avgSalary);
        let senior = {
          experienceLevel: `${EXPERIENCE_LEVELS.SENIOR_LEVEL} ${title?.toLowerCase?.()}`,
          avgSalary: salaries[salaries.length - 1],
          hourlyRate: null,
        };
        senior.hourlyRate = yearlySalaryToHourlyRate(senior.avgSalary);
        return [junior, mid, senior].map((r) => ({
          ...r,
          avgSalary: formatter(false).format(r.avgSalary),
          hourlyRate: '$' + yearlySalaryToHourlyRate(r.avgSalary),
          avgSalaryDisplayInK: kCurrencyFormatter(r.avgSalary),
        }));
      }
    } catch (e) {
      console.error(e);
      return [];
    }
  }, [title, salaries]);

  return (
    <>
      {salaryByLevelContent && salaryByLevelContent.content && (
        <div
          className={classNames('w-730 z-mb-48')}
          dangerouslySetInnerHTML={{ __html: salaryByLevelContent.content }}
        />
      )}
      {tableData.length !== 0 ? (
        <div className={classNames('mt-5', salaryPageStyles['salary-by-experience-table'])}>
          <Table
            columnConfig={{
              experienceLevel: {
                columnName: 'Experience Level',
              },
              avgSalary: {
                columnName: 'Avg. Salary',
              },
              hourlyRate: {
                columnName: 'Hourly Rate',
              },
            }}
            bodyData={tableData}
            scrollOnMobile
            tableHeaderTitleContent={<h3 className="zp-title-h3 text-capitalize mb-4">{`${title} salary by experience level`}</h3>}
          />
        </div>
      ) : null}
    </>
  );
}

SalaryByExperienceLevel.defaultProps = {
  salaryByLevel: [],
  salaryByLevelContent: {},
};

SalaryByExperienceLevel.propTypes = {
  salaryByLevel: PropTypes.arrayOf(
    PropTypes.shape({
      level: PropTypes.number,
      median: PropTypes.number,
    })
  ),
  salaryByLevelContent: PropTypes.object,
};
